/* eslint-disable no-underscore-dangle */
import 'common/utils/domNormalizeHack'
import { Query, QueryKeys } from 'publisher/components/core/MatchMedia'
import configureStore from 'publisher/entrypoints/simple/configureStore'
import { selectors } from 'publisher/reducers/optInReducer'
import { selectors as pageSelectors } from 'publisher/reducers/pageReducer'
import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { compose } from 'redux'
import { Level } from 'rollbar'
import { initializeInterceptors } from 'src/publisher/api/initialize-interceptors'
import { initPublisherSentry } from 'src/publisher/utils/init-sentry'
import { normalizeStringBoolean } from '../../store'
import BaseApp from '../base-app'
import { createEntityElement } from './create-entity-element'
import { createPage } from './create-page'

initPublisherSentry()
initializeInterceptors()

declare global {
  interface Window {
    __ROLLBAR_LEVEL__?: Level
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
    __PRELOADED_STATE__?: any
    visitor: string
  }
}

const rollbarReportLevel = window.__ROLLBAR_LEVEL__
const preloadedState = window.__PRELOADED_STATE__
window.__PRELOADED_STATE__ = undefined
// Allow the passed state to be garbage-collected
const isDesktop = window.matchMedia(Query[QueryKeys.DESKTOP]).matches
preloadedState.management.isDesktop = isDesktop
preloadedState.management.isMobile = normalizeStringBoolean(
  preloadedState.management.isMobile,
)
window.visitor = preloadedState.optIn.customerCountry
const store: any = configureStore(preloadedState)

if (pageSelectors.getCountryFieldId(preloadedState.page)) {
  preloadedState.optIn.fields.country = selectors.getCustomerCountry(
    preloadedState.optIn,
  )
}

// biome-ignore lint/style/noNonNullAssertion: <explanation>
const rootElement = document.getElementById('app')!

hydrateRoot(
  rootElement,
  <BaseApp
    createEntityElement={createEntityElement}
    createPage={createPage}
    store={store}
    rollbarReportLevel={rollbarReportLevel}
  />,
)
